import {Component, inject, signal} from '@angular/core';
import {CustomerProfile} from '@core/interfaces/generated/graphql';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {LoginSignupFormComponent} from '@layout/components/user-universe/login-signup/login-signup-form.component';
import {NgbAlert, NgbModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
  imports: [
    LoginSignupFormComponent,
    ModalContainerComponent,
    NgbAlert
  ]
})
export class LoginModalComponent {
  private modalService = inject(NgbModal);

  email: string | undefined = undefined;
  message = signal('');

  loginSuccess(customer?: CustomerProfile) {
    this.modalService.dismissAll();
    if (customer?.isEmailConfirmed === false) {
      this.openEmailConfirmModal();
    } else {
      this.openWelcomeModal();
    }
  }

  openWelcomeModal() {
    import('../welcome-modal/welcome-modal.component').then(comp => {
      const modalRef = this.modalService.open(comp.WelcomeModalComponent);
      modalRef.componentInstance.message.set($localize`Du er logget ind. Hvad vil du gerne se?`);
    });
  }

  openEmailConfirmModal() {
    import('../account-not-confirmed-modal/account-not-confirmed-modal.component').then(comp => {
      this.modalService.open(comp.AccountNotConfirmedModalComponent);
    });
  }
}
